// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/tournaments-winter.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calendar_wrapper__og-2T {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  padding-bottom: 80px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy {
  padding-top: 60px;
  transition: all 0.2s linear;
  margin: 0 auto;
  margin-bottom: 70px;
  width: 85%;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_mobHeader__7XfGQ {
  display: none;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_title__WbsZr {
  font-size: 64px;
  font-weight: 700;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  font-size: 40px;
  margin-top: 30px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU {
  align-items: center;
  border-bottom: 1px solid rgba(224, 224, 224, 0.3490196078);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding-bottom: 31px;
  margin-bottom: 24px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_month__9iVd8 {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  align-items: center;
  color: #fff;
  display: flex;
  gap: 20px;
  justify-content: center;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_month__9iVd8 .Calendar_arrowWrapper__ukiXT {
  align-items: center;
  background-color: rgba(250, 249, 248, 0.2);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_month__9iVd8 .Calendar_monthTxt__lBWk1 {
  align-items: center;
  display: flex;
  padding-top: 5px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL .Calendar_filterWrapper__jmNBt {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 100px;
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 10px 16px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL .Calendar_activeFilter__IwjJS {
  background-color: rgba(255, 255, 255, 0.3);
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_grid__WwfW\\+ {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayOfWeek__d0Ktr {
  text-align: center;
  margin-bottom: 24px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayOfWeekWrapper__E0Nej {
  background-color: #FFFFFF;
  border-radius: 100px;
  color: #1B1E23;
  display: inline;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ {
  min-height: 217px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 {
  border: 1px solid rgba(220, 220, 220, 0.1019607843);
  padding-top: 31px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6509803922);
  border-radius: 8px;
  padding-bottom: 31px;
  position: relative;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_dayNum__rx9Xs,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_dayNum__rx9Xs {
  left: 10px;
  position: absolute;
  top: 10px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_game__Y5jI2 {
  bottom: 8px;
  display: flex;
  gap: 10px;
  left: 8px;
  position: absolute;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0 {
  align-items: center;
  background-color: #611D14;
  border-radius: 100px;
  display: flex;
  gap: 4px;
  font-size: 13px;
  font-weight: 400;
  padding: 6px 7px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItemCS__oeAO8,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_game__Y5jI2 .Calendar_gameItemCS__oeAO8 {
  background-color: #614714;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItemLol__Em77v,
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 .Calendar_game__Y5jI2 .Calendar_gameItemLol__Em77v {
  background-color: rgba(199, 155, 59, 0.1490196078);
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_dayEmpty__wdB\\+2 {
  background-color: transparent;
  border: none;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_today__E1aI4 {
  background-color: #1d1e21;
  border: 2px solid rgba(220, 220, 220, 0.3);
  z-index: 0;
  padding-top: 36px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_today__E1aI4 .Calendar_dayNum__rx9Xs {
  color: #292621;
  background-color: #FFFFFF;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_event__Xn0qW {
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
  padding: 4px 8px;
  background-color: rgba(0, 123, 255, 0.7);
  font-size: 12px;
  text-overflow: ellipsis;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
  position: fixed;
  top: 0;
  z-index: 2;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB {
  background-color: #1B1E23;
  border-radius: 8px;
  width: 50%;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalImg__8CLfD {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 193px;
  width: 100%;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy {
  padding: 16px 20px;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalTitle__pZ-Mi {
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 700;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ {
  align-items: center;
  border-bottom: 1px solid rgba(224, 224, 224, 0.3490196078);
  display: flex;
  gap: 16px;
  margin-top: 16px;
  padding-bottom: 16px;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ .Calendar_modalGameItem__pUBkb {
  align-items: center;
  background-color: #611D14;
  border-radius: 100px;
  color: #fff;
  display: flex;
  gap: 4px;
  font-size: 13px;
  font-weight: 400;
  padding: 6px 7px;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ .Calendar_modalGameItemCS__pp22W {
  background-color: #614714;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ .Calendar_modalGameItemLol__wrK0i {
  background-color: rgba(199, 155, 59, 0.1490196078);
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalGame__zRFMZ .Calendar_modalCalendar__mmtwP {
  align-items: center;
  color: #FFFFFF;
  display: flex;
  font-size: 16px;
  font-weight: 500;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalDescription__d6bbJ {
  color: #E0E0E0;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  margin-top: 16px;
}
.Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB .Calendar_modalInfo__D\\+XEy .Calendar_modalBtns__KL8Vu {
  display: flex;
  gap: 16px;
  justify-content: end;
  margin-top: 20px;
}

@media (max-width: 1291px) {
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0 .Calendar_gameItemName__P3PRV {
    display: none;
  }
}
@media (max-width: 1100px) {
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU {
    display: none;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_emptyDiv__\\+RH68 {
    display: none;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_month__9iVd8 {
    font-size: 18px;
    gap: 6px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_arrowWrapper__ukiXT {
    height: 24px;
    width: 24px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL {
    justify-content: unset;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_header__GpjMU .Calendar_filter__EMCSL .Calendar_filterWrapper__jmNBt {
    padding: 8px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_mobHeader__7XfGQ {
    display: block;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_mobHeader__7XfGQ .Calendar_filter__EMCSL {
    align-items: center;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_mobHeader__7XfGQ .Calendar_filter__EMCSL .Calendar_filterWrapper__jmNBt {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    align-items: center;
    background-color: rgba(220, 220, 220, 0.0509803922);
    border-radius: 100px;
    color: #E0E0E0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 10px 16px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_mobHeader__7XfGQ .Calendar_filter__EMCSL .Calendar_activeFilter__IwjJS {
    background-color: #333217;
    color: #ead40c;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_mobHeader__7XfGQ .Calendar_month__9iVd8 {
    font-weight: 600;
    font-size: 20px;
    align-items: center;
    color: #fff;
    display: flex;
    gap: 20px;
    justify-content: center;
    margin-bottom: 24px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_mobHeader__7XfGQ .Calendar_month__9iVd8 .Calendar_arrowWrapper__ukiXT {
    align-items: center;
    background-color: rgba(250, 249, 248, 0.2);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_mobHeader__7XfGQ .Calendar_month__9iVd8 .Calendar_monthTxt__lBWk1 {
    align-items: center;
    display: flex;
    padding-top: 5px;
  }
}
@media (max-width: 700px) {
  .Calendar_wrapper__og-2T .Calendar_modal__xufwr .Calendar_modalWrapper__DnmUB {
    height: 100%;
    width: 100%;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ {
    min-height: 157px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 {
    gap: unset;
    justify-content: space-between;
    left: 6px;
    right: 6px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0 {
    align-items: center;
    background-color: unset;
    display: flex;
    justify-content: center;
    padding: unset;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_day__UsmN\\+ .Calendar_game__Y5jI2 .Calendar_gameItem__p8pi0 img {
    height: 8px;
    width: 8px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_event__Xn0qW {
    padding: 4px 2px;
  }
  .Calendar_wrapper__og-2T .Calendar_container__bjtjy .Calendar_event__Xn0qW .Calendar_eventName__NM57F {
    font-size: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Tournaments/Calendar/Calendar.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EAKE,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,oBAAA;AALF;AAOE;EACE,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AALJ;AAOI;EACE,aAAA;AALN;AAQI;ECtBF,eAAA;EACA,gBAAA;EACA,kBAAA;EDuBI,mBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AALN;AAQI;EACE,mBAAA;EACA,0DAAA;EACA,aAAA;EACA,kCAAA;EACA,oBAAA;EACA,mBAAA;AANN;AAQM;ECvBJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDwBM,mBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AALR;AAOQ;EACE,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AALV;AAQQ;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;AANV;AAUM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AARR;AAUQ;ECoFN,eAAA;EACA,gBAAA;EACA,kBAAA;EDnFQ,mBAAA;EACA,0CE/BC;EFgCD,oBAAA;EACA,cEDG;EFEH,eAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAPV;AAUQ;EACE,0CEvCC;AF+BX;AAaI;EACE,aAAA;EACA,qCAAA;AAXN;AAcI;EACE,kBAAA;EACA,mBAAA;AAZN;AAeI;EACE,yBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAbN;AAgBI;EACE,iBAAA;AAdN;AAiBI;;EAEE,mDAAA;EAEA,iBAAA;EACA,WAAA;EACA,6CAAA;EACA,kBAAA;EAEA,oBAAA;EACA,kBAAA;AAjBN;AAmBM;;EACE,UAAA;EACA,kBAAA;EACA,SAAA;AAhBR;AAmBM;;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;AAhBR;AAkBQ;;EACE,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAfV;AAkBQ;;EACE,yBAAA;AAfV;AAkBQ;;EACE,kDAAA;AAfV;AAoBI;EACE,6BAAA;EACA,YAAA;AAlBN;AAqBI;EACE,yBAAA;EACA,0CAAA;EAEA,UAAA;EACA,iBAAA;AApBN;AAsBM;EACE,cEhGI;EFiGJ,yBElGK;EFmGL,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AApBR;AAwBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,uBAAA;AAtBN;AA0BE;EACE,mBAAA;EACA,oCAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,MAAA;EACA,UAAA;AAxBJ;AA0BI;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;AAxBN;AA0BM;EACE,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;AAxBR;AA2BM;EACE,kBAAA;AAzBR;AA2BQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAzBV;AA4BQ;EACE,mBAAA;EACA,0DAAA;EAEA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AA3BV;AA8BU;EACE,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA5BZ;AA+BU;EACE,yBAAA;AA7BZ;AAgCU;EACE,kDAAA;AA9BZ;AAiCU;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AA/BZ;AAmCQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAjCV;AAoCQ;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AAlCV;;AAyCA;EASU;IACE,aAAA;EA9CV;AACF;AAqDA;EAKM;IACE,aAAA;EAvDN;EAyDM;IACE,aAAA;EAvDR;EA0DM;IACE,eAAA;IACA,QAAA;EAxDR;EA2DM;IACE,YAAA;IACA,WAAA;EAzDR;EA4DM;IACE,sBAAA;EA1DR;EA4DQ;IACE,YAAA;EA1DV;EA+DI;IACE,cAAA;EA7DN;EA+DM;IACE,mBAAA;IACA,aAAA;IACA,SAAA;IACA,yBAAA;IACA,gBAAA;IACA,mBAAA;EA7DR;EA+DQ;IClMR,eAAA;IACA,gBAAA;IACA,kBAAA;IDmMU,mBAAA;IACA,mDAAA;IACA,oBAAA;IACA,cAAA;IACA,eAAA;IACA,aAAA;IACA,uBAAA;IACA,kBAAA;EA5DV;EA+DQ;IACE,yBAAA;IACA,cAAA;EA7DV;EAiEM;IACE,gBAAA;IACA,eAAA;IACA,mBAAA;IACA,WAAA;IACA,aAAA;IACA,SAAA;IACA,uBAAA;IACA,mBAAA;EA/DR;EAiEQ;IACE,mBAAA;IACA,0CAAA;IACA,kBAAA;IACA,eAAA;IACA,aAAA;IACA,YAAA;IACA,uBAAA;IACA,WAAA;EA/DV;EAkEQ;IACE,mBAAA;IACA,aAAA;IACA,gBAAA;EAhEV;AACF;AAuEA;EAKM;IACE,YAAA;IACA,WAAA;EAzEN;EA+EI;IACE,iBAAA;EA7EN;EA+EM;IACE,UAAA;IACA,8BAAA;IACA,SAAA;IACA,UAAA;EA7ER;EA+EQ;IACE,mBAAA;IACA,uBAAA;IACA,aAAA;IACA,uBAAA;IAGA,cAAA;EA/EV;EAiFU;IACE,WAAA;IACA,UAAA;EA/EZ;EAuFI;IACE,gBAAA;EArFN;EAuFM;IACE,cAAA;EArFR;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.wrapper {\n  // main-season down\n  // background-image: url('../../../assets/images/tournaments.jpg');\n\n  //Winter-season down\n  background-image: url('../../../assets/images/tournaments-winter.jpg');\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding-bottom: 80px;\n\n  .container {\n    padding-top: 60px;\n    transition: all 0.2s linear;\n    margin: 0 auto;\n    margin-bottom: 70px;\n    width: 85%;\n\n    .mobHeader {\n      display: none;\n    }\n\n    .title {\n      @include h1;\n\n      align-items: center;\n      color: #ffffff;\n      display: flex;\n      justify-content: space-between;\n      font-size: 40px;\n      margin-top: 30px;\n    }\n\n    .header {\n      align-items: center;\n      border-bottom: 1px solid #E0E0E059;\n      display: grid;\n      grid-template-columns: 1fr 1fr 1fr;\n      padding-bottom: 31px;\n      margin-bottom: 24px;\n\n      .month {\n        @include subtitle1b;\n\n        align-items: center;\n        color: #fff;\n        display: flex;\n        gap: 20px;\n        justify-content: center;\n\n        .arrowWrapper {\n          align-items: center;\n          background-color: #FAF9F833;\n          border-radius: 50%;\n          cursor: pointer;\n          display: flex;\n          height: 32px;\n          justify-content: center;\n          width: 32px;\n        }\n\n        .monthTxt {\n          align-items: center;\n          display: flex;\n          padding-top: 5px;\n        }\n      }\n\n      .filter {\n        align-items: center;\n        display: flex;\n        gap: 12px;\n        justify-content: flex-end;\n\n        .filterWrapper {\n          @include body1;\n\n          align-items: center;\n          background-color: $light-10;\n          border-radius: 100px;\n          color: $text-white;\n          cursor: pointer;\n          display: flex;\n          justify-content: center;\n          padding: 10px 16px;\n        }\n\n        .activeFilter {\n          background-color: $light-30;\n        }\n      }\n    }\n\n    .grid {\n      display: grid;\n      grid-template-columns: repeat(7, 1fr);\n    }\n\n    .dayOfWeek {\n      text-align: center;\n      margin-bottom: 24px;\n    }\n\n    .dayOfWeekWrapper {\n      background-color: #FFFFFF;\n      border-radius: 100px;\n      color: #1B1E23;\n      display: inline;\n      font-size: 14px;\n      font-weight: 500;\n      padding: 6px 12px;\n    }\n\n    .day {\n      min-height: 217px;\n    }\n\n    .day,\n    .dayEmpty {\n      border: 1px solid #DCDCDC1A;\n      // padding: 10px;\n      padding-top: 31px;\n      color: #fff;\n      background-color: #000000A6;\n      border-radius: 8px;\n      // height: 217px;\n      padding-bottom: 31px;\n      position: relative;\n\n      .dayNum {\n        left: 10px;\n        position: absolute;\n        top: 10px;\n      }\n\n      .game {\n        bottom: 8px;\n        display: flex;\n        gap: 10px;\n        left: 8px;\n        position: absolute;\n\n        .gameItem {\n          align-items: center;\n          background-color: #611D14;\n          border-radius: 100px;\n          display: flex;\n          gap: 4px;\n          font-size: 13px;\n          font-weight: 400;\n          padding: 6px 7px;\n        }\n\n        .gameItemCS {\n          background-color: #614714;\n        }\n\n        .gameItemLol {\n          background-color: #C79B3B26;\n        }\n      }\n    }\n\n    .dayEmpty {\n      background-color: transparent;\n      border: none;\n    }\n\n    .today {\n      background-color: #1d1e21;\n      border: 2px solid rgba(220, 220, 220, 0.3);\n      // transform: scale(1.05);\n      z-index: 0;\n      padding-top: 36px;\n\n      .dayNum {\n        color: $text-dark;\n        background-color: $text-white;\n        border-radius: 50%;\n        width: 24px;\n        height: 24px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 12px;\n      }\n    }\n\n    .event {\n      cursor: pointer;\n      font-size: 13px;\n      font-weight: 500;\n      margin-bottom: 4px;\n      padding: 4px 8px;\n      background-color: rgba(0, 123, 255, 0.7);\n      font-size: 12px;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .modal {\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.5);\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    left: 0;\n    right: 0;\n    position: fixed;\n    top: 0;\n    z-index: 2;\n\n    .modalWrapper {\n      background-color: #1B1E23;\n      border-radius: 8px;\n      width: 50%;\n\n      .modalImg {\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center;\n        height: 193px;\n        width: 100%;\n      }\n\n      .modalInfo {\n        padding: 16px 20px;\n\n        .modalTitle {\n          color: #FFFFFF;\n          font-size: 24px;\n          font-weight: 700;\n        }\n\n        .modalGame {\n          align-items: center;\n          border-bottom: 1px solid #E0E0E059;\n\n          display: flex;\n          gap: 16px;\n          margin-top: 16px;\n          padding-bottom: 16px;\n\n\n          .modalGameItem {\n            align-items: center;\n            background-color: #611D14;\n            border-radius: 100px;\n            color: #fff;\n            display: flex;\n            gap: 4px;\n            font-size: 13px;\n            font-weight: 400;\n            padding: 6px 7px;\n          }\n\n          .modalGameItemCS {\n            background-color: #614714;\n          }\n\n          .modalGameItemLol {\n            background-color: #C79B3B26;\n          }\n\n          .modalCalendar {\n            align-items: center;\n            color: #FFFFFF;\n            display: flex;\n            font-size: 16px;\n            font-weight: 500;\n          }\n        }\n\n        .modalDescription {\n          color: #E0E0E0;\n          font-size: 16px;\n          font-weight: 400;\n          line-height: 150%;\n          margin-top: 16px;\n        }\n\n        .modalBtns {\n          display: flex;\n          gap: 16px;\n          justify-content: end;\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1291px) {\n  .wrapper {\n\n    .container {\n\n      .game {\n\n        .gameItem {\n\n          .gameItemName {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .wrapper {\n\n    .container {\n\n      .header {\n        display: none;\n\n        .emptyDiv {\n          display: none;\n        }\n\n        .month {\n          font-size: 18px;\n          gap: 6px;\n        }\n\n        .arrowWrapper {\n          height: 24px;\n          width: 24px;\n        }\n\n        .filter {\n          justify-content: unset;\n\n          .filterWrapper {\n            padding: 8px;\n          }\n        }\n      }\n\n      .mobHeader {\n        display: block;\n\n        .filter {\n          align-items: center;\n          display: flex;\n          gap: 12px;\n          justify-content: flex-end;\n          margin-top: 24px;\n          margin-bottom: 24px;\n\n          .filterWrapper {\n            @include body1;\n\n            align-items: center;\n            background-color: #DCDCDC0D;\n            border-radius: 100px;\n            color: #E0E0E0;\n            cursor: pointer;\n            display: flex;\n            justify-content: center;\n            padding: 10px 16px;\n          }\n\n          .activeFilter {\n            background-color: #333217;\n            color: #ead40c;\n          }\n        }\n\n        .month {\n          font-weight: 600;\n          font-size: 20px;\n          align-items: center;\n          color: #fff;\n          display: flex;\n          gap: 20px;\n          justify-content: center;\n          margin-bottom: 24px;\n\n          .arrowWrapper {\n            align-items: center;\n            background-color: #FAF9F833;\n            border-radius: 50%;\n            cursor: pointer;\n            display: flex;\n            height: 32px;\n            justify-content: center;\n            width: 32px;\n          }\n\n          .monthTxt {\n            align-items: center;\n            display: flex;\n            padding-top: 5px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 700px) {\n  .wrapper {\n\n    .modal {\n\n      .modalWrapper {\n        height: 100%;\n        width: 100%;\n      }\n    }\n\n    .container {\n\n      .day {\n        min-height: 157px;\n\n        .game {\n          gap: unset;\n          justify-content: space-between;\n          left: 6px;\n          right: 6px;\n\n          .gameItem {\n            align-items: center;\n            background-color: unset;\n            display: flex;\n            justify-content: center;\n            // height: 16px;\n            // width: 16px;\n            padding: unset;\n\n            img {\n              height: 8px;\n              width: 8px;\n            }\n          }\n        }\n      }\n\n\n\n      .event {\n        padding: 4px 2px;\n\n        .eventName {\n          font-size: 6px;\n        }\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #F2F740;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n// New colors\n\n$icon-main: #EAD40C;\n$icon-secondary: #7B756B;\n$icon-chevron: #BBB5AA;\n$icon-always-dark: #212329;\n$icon-primary-control: #292621;\n$icon-hover: #575249;\n$icon-pressed: #575249;\n$icon-white: #ffffff;\n$icon-notification: #FF3333;\n$icon-warning: #E2B603;\n$icon-deposit: #009E69;\n\n$light-10: rgba(255, 255, 255, .1);\n$light-15: rgba(255, 255, 255, .15);\n$light-30: rgba(255, 255, 255, .3);\n$light-45: rgba(255, 255, 255, .45);\n$light-50: rgba(255, 255, 255, .5);\n$light-60: rgba(255, 255, 255, .6);\n\n$background-main: #171716;\n$background-secondary: #292621;\n$background-snackbar: #000000;\n$background-input: #3E3C37;\n\n$control-primary: #F2F740;\n$control-hover: #F5F966;\n$control-pressed: #E6EB3D;\n$control-green: #009E69;\n$control-green-hover: #33B187;\n$control-green-pressed: #009664;\n$control-dark: #3E3C37;\n$control-dark-hover: #51504B;\n$control-dark-pressed: #3B3934;\n$control-light: #FFFFFF;\n$control-light-hover: #E5E5E5;\n$control-light-pressed: #D9D9D9;\n$control-light-toggle: #B7B7B7;\n\n$text-title: #FAF9F8;\n$text-subtitle: #DAD6CE;\n$text-body: #C2BDB2;\n$text-link: #00D68F;\n$text-error: #FF3333;\n$text-warning: #E2B603;\n$text-white: #FFFFFF;\n$text-dark: #292621;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Calendar_wrapper__og-2T`,
	"container": `Calendar_container__bjtjy`,
	"mobHeader": `Calendar_mobHeader__7XfGQ`,
	"title": `Calendar_title__WbsZr`,
	"header": `Calendar_header__GpjMU`,
	"month": `Calendar_month__9iVd8`,
	"arrowWrapper": `Calendar_arrowWrapper__ukiXT`,
	"monthTxt": `Calendar_monthTxt__lBWk1`,
	"filter": `Calendar_filter__EMCSL`,
	"filterWrapper": `Calendar_filterWrapper__jmNBt`,
	"activeFilter": `Calendar_activeFilter__IwjJS`,
	"grid": `Calendar_grid__WwfW+`,
	"dayOfWeek": `Calendar_dayOfWeek__d0Ktr`,
	"dayOfWeekWrapper": `Calendar_dayOfWeekWrapper__E0Nej`,
	"day": `Calendar_day__UsmN+`,
	"dayEmpty": `Calendar_dayEmpty__wdB+2`,
	"dayNum": `Calendar_dayNum__rx9Xs`,
	"game": `Calendar_game__Y5jI2`,
	"gameItem": `Calendar_gameItem__p8pi0`,
	"gameItemCS": `Calendar_gameItemCS__oeAO8`,
	"gameItemLol": `Calendar_gameItemLol__Em77v`,
	"today": `Calendar_today__E1aI4`,
	"event": `Calendar_event__Xn0qW`,
	"modal": `Calendar_modal__xufwr`,
	"modalWrapper": `Calendar_modalWrapper__DnmUB`,
	"modalImg": `Calendar_modalImg__8CLfD`,
	"modalInfo": `Calendar_modalInfo__D+XEy`,
	"modalTitle": `Calendar_modalTitle__pZ-Mi`,
	"modalGame": `Calendar_modalGame__zRFMZ`,
	"modalGameItem": `Calendar_modalGameItem__pUBkb`,
	"modalGameItemCS": `Calendar_modalGameItemCS__pp22W`,
	"modalGameItemLol": `Calendar_modalGameItemLol__wrK0i`,
	"modalCalendar": `Calendar_modalCalendar__mmtwP`,
	"modalDescription": `Calendar_modalDescription__d6bbJ`,
	"modalBtns": `Calendar_modalBtns__KL8Vu`,
	"gameItemName": `Calendar_gameItemName__P3PRV`,
	"emptyDiv": `Calendar_emptyDiv__+RH68`,
	"eventName": `Calendar_eventName__NM57F`
};
export default ___CSS_LOADER_EXPORT___;
